import styled, { css } from 'styled-components';

const clsPrefix = 'ui-form-field';

export const fieldClasses = {
  wrapper: clsPrefix,
  content: `${clsPrefix}-content`,
  header: `${clsPrefix}-header`,
  footer: `${clsPrefix}-footer`,
} as const;

export const FormFieldSC = styled.div<{ noStyle?: boolean; hasHeader?: boolean }>`
  display: inline-flex;
  flex-direction: column;
  width: 100%;

  ${({ noStyle }) =>
    noStyle
      ? ''
      : css`
          margin: 8px 0;
        `};

  .${fieldClasses.content} {
    width: 100%;
    margin-top: ${({ hasHeader }) => (hasHeader ? '8px' : '0px')};
  }
`;
